import type { ReactNode } from 'react';

export interface PageHeaderProps {
  eyebrow?: string;
  title: string;
  description?: string;
  actions?: ReactNode;
}

export function PageHeader({ eyebrow, title, description, actions }: PageHeaderProps) {
  return (
    <div className="mb-6 flex flex-col gap-1 sm:flex-row sm:items-start sm:justify-between">
      <div className="min-w-0 flex-1">
        {eyebrow ? <p className="jq-eyebrow jq-eyebrow--leader mb-3">{eyebrow}</p> : null}
        <h1 className="jq-h3 text-foreground">{title}</h1>
        {description ? (
          <p className="jq-body-sm mt-1 text-muted-foreground">{description}</p>
        ) : null}
      </div>
      {actions ? (
        <div className="mt-2 flex shrink-0 items-center gap-2 sm:mt-0">{actions}</div>
      ) : null}
    </div>
  );
}
